import { API_URL, jwtToken } from "../../../context/appContext";
export default async function editTriangular(strategy) {
    return fetch(`${API_URL}/api/triangular_edit_process`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + jwtToken
        }, body: JSON.stringify(strategy)
    })
        .then(res => res.json())
        .then(res => res)
        .catch(err => console.log({ err }))
}
